import { DatePipe } from '@angular/common';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TransactionResult } from 'src/app/core/services/interfaces/transaction-result';
import { IVisits } from '../Interfaces/IVisits';
import { VisitsService } from '../services/visits-service';
import { NewVisitComponent } from './new-visit/new-visit.component';
import { IMyApprovals } from '../Interfaces/IMyApprovals';
import { IScreens } from '../Interfaces/IScreens';
import { RolesService } from '../services/roles-service';
import { NotificationService } from '../../../../core/services/notification/notification.service';
import { IRecordStatus } from '../Interfaces/IRecordStatus';
import { ApprovalHistoryComponent } from './approval-history/approval-history.component';
import { TranslateApplicationService } from 'src/app/core/translate/translate-application-service';
import { ApproversAreasService } from '../services/approversAreas-service';
import { SitesService } from '../services/sites-services';
import { ISitesConfigurations } from '../Interfaces/ISitesConfigurations';

declare var $: any;

interface Status {
  label: string;
  value: {
      recordstatus: string;
      pkrecordstatus: number;
  };
}

interface StatusValues {
	recordstatus: string;
	pkrecordstatus: number;
}

@Component({
  selector: 'app-my-requests',
  templateUrl: './my-requests.component.html',
  styles: [
  ]
})
export class MyRequestsComponent implements OnInit {
  formGroup: FormGroup;
  columns: Array<any> = [
    'pkvisit',
    'visittype',
    'approvalhistory',
    'recordstatus',
    'strstartdatevisit',
    'strenddatevisit',
    'building',
    'activity',
    'areaproject',
    'sponsor',
    'strcreationdate',
    'employeecreatorname',
    'strlastupdated',
    'employeeupdatername',
    'namerecordstatus'
  ];
  
  displayedColumns: Array<string> = this.columns.map((c) => c.columnDef);
  listData: Array<IVisits> = [];
  loading = false;
  station: string = 'TABLE';
  listRecordStatus: Array<IRecordStatus> = [];
  listRecordStatusNG: Status[] = [];
  selectedRecordStatus: Array<Status> = [];
  isEmpty = false;
  hasHistory = false;

  constructor(
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private roleService: RolesService,
    private router: Router,
    private translate: TranslateApplicationService,
    private visitsService: VisitsService,
    private SitesService: SitesService,
  ) {
    this.formGroup = this.formBuilder.group({
      cbStatus:[]
    });
  }

  ngOnInit(): void {
   this.GetStatus();
   const component = this;
		$('.btnReload').click(function () {
			component.GetRequestByUserComponent();
		});
	  component.GetRequestByUserComponent();
  }

  ngAfterViewInit(){
		$('.p-multiselect.p-multiselect .p-multiselect-label').removeAttr('style', '');
    $('.p-multiselect.p-multiselect .p-multiselect-label').attr('style', 'width: 160px;');
    $('.p-multiselect').attr('style', 'margin-left: 15px; margin-bottom: 10px;');

	}

  Alert(title: string, message: string) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: title,
			message: this.translate.TranslateKey(message),
			shown: true,
		});
	}

  GetRequestByUserComponent() {
		this.loading = true;
    if(window.localStorage.getItem('pksite') != null && window.localStorage.getItem('pksite') != 'null'){
      this.roleService.EmployeeHasPermissionToScreen('My request').subscribe(
      (result: TransactionResult<IScreens[]>) => {
        this.loading = false;
        if (result.success) {
          if (result.data == null || result.data.length == 0)
            this.router.navigateByUrl('/main/without-permission');
        } else {
          this.Alert("Error", "ERROR.Get_user_permissions_fail");
        }
      },
      (error: any) => { 
        this.ErrorAlert(error); this.loading = false; 
      });
    }
		this.GetRequestByUser(this.formGroup.value);
  }
  
  search(){
    this.GetRequestByUser(this.formGroup.value);
  }
  
  GetStatus() {
    this.loading = true;
    this.visitsService.GetStatus().subscribe(
    (result: TransactionResult<IRecordStatus[]>) => {
      if (result.success) {
        this.loading = false;
        let st : StatusValues[] = [];
        result.data.forEach((obj) => {
          if(obj.recordstatus.toLocaleLowerCase() == 'draft' || obj.recordstatus.toLocaleLowerCase() == 'in progress'){
            let st2 : StatusValues = { recordstatus: obj.recordstatus, pkrecordstatus: obj.pkrecordstatus }
            st.push(st2);
          }
          this.listRecordStatus.push(obj);
          this.listRecordStatusNG.push({
            label: obj.recordstatus,
            value: {
                recordstatus: obj.recordstatus,
                pkrecordstatus: obj.pkrecordstatus,
            }
          });
        });
        this.formGroup.controls.cbStatus.setValue(st);
        this.search();
      } else {
        this.loading = false;
        this.Alert("Error", "ERROR.Get_record_status_fail");
      }
    },
      (error: any) => {
        this.loading = false;
        this.ErrorAlert(error);
    });
  }

  Add() {
    let valueEmpty = false;
    this.SitesService.GetSitesConfigurations().subscribe(
    (result: TransactionResult<ISitesConfigurations[]>) => {
      this.loading = false;
      if (result.success) {
        result.data.forEach((element) => {
          if(element.value.trim()=='' && !valueEmpty){
            valueEmpty = true;
            this.Alert("Error", "ERROR.Configuration_site_empty");
          }
        });
        if(!valueEmpty){
          const dialogRef = this.dialog.open(NewVisitComponent, {
            data: {}
          });
          dialogRef.afterClosed().subscribe(result => {
            if(result){
              this.GetRequestByUser(this.formGroup.value);
            }
          });
          dialogRef.backdropClick().subscribe(result => {
            if(result){
              this.GetRequestByUser(this.formGroup.value);
            }
          });
        }
      }
      else{
        this.ErrorAlert(result.message);
      }
    },
    (error) => {
      this.ErrorAlert(error);
      this.loading = false;
    });
  }

  Edit(item: IVisits) {
    const dialogRef = this.dialog.open(NewVisitComponent, {
      data: item
		});
		dialogRef.afterClosed().subscribe(result => {
			if(result){
        const component = this;
        component.GetRequestByUser(this.formGroup.value);
			}
    });
    dialogRef.backdropClick().subscribe(result => {
			if(result){
        const component = this;
        component.GetRequestByUser(this.formGroup.value);
			}
		});
  }

  GetRequestByUser(value: FormGroup) {
    this.loading = true;
    if (window.localStorage.getItem('pksite') != null && window.localStorage.getItem('pksite') != 'null' ) {
      this.visitsService.GetVisitsByUser(value).subscribe(
      (result: TransactionResult<IVisits[]>) => {
        if (result.success) {
          this.listData = result.data;
          this.listData.forEach(element => {
            element.strstartdatevisit = this.datePipe.transform(element.startdatevisit, "yyyy-MM-dd HH:mm:ss");
            element.strenddatevisit = this.datePipe.transform(element.enddatevisit, "yyyy-MM-dd HH:mm:ss");
            element.strcreationdate = this.datePipe.transform(element.creationdate, "yyyy-MM-dd HH:mm:ss");
            element.strlastupdated = this.datePipe.transform(element.lastupdated, "yyyy-MM-dd HH:mm:ss");

            /* Validate if the request has an approval history to show/hide approval history button */
            this.loading = true;
            /*this.approversAreasService.GetApproversAreasByVisitorByVisit(element.pkvisit).subscribe(
              (result: TransactionResult<IApproversAreas[]>) => {
                this.loading = false;
                if (result.success && result.data.length > 0 && element.recordstatus.trim().toLowerCase() != 'draft') {
                  element.hasHistory = true;
                } else {
                  element.hasHistory = false;
                }
              },
              (error: any) => { this.ErrorAlert(error); this.loading = false; });*/
          });
          this.loading = false;
        } else {
          this.loading = false;
          this.Alert("Error", "ERROR.Get_requests_by_user_fail");
        }
      },(error: any) => {
        this.loading = false;
        this.ErrorAlert(error);
    });
    }
  }

  View(item: IVisits) {
    item.isViewing = true;
    const dialogRef = this.dialog.open(NewVisitComponent, {
      data: item
		});
		dialogRef.afterClosed().subscribe(result => {
			if(result){
        const component = this;
        component.GetRequestByUser(this.formGroup.value);
			}
    });
    dialogRef.backdropClick().subscribe(result => {
			if(result){
        const component = this;
        component.GetRequestByUser(this.formGroup.value);
			}
		});
  }

  ErrorAlert(message: any) {
		this.notificationService.AddAlert({
		  icon: 'all_inbox',
		  title: 'Error',
		  message: message,
		  shown: true,
		});
	}

  ShowApprovalHistory(item: IMyApprovals) {
    const dialogRef = this.dialog.open(ApprovalHistoryComponent, {
      data: item
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        setTimeout(() => this.GetRequestByUser(this.formGroup.value), 1000);
      }
    });
  }
}
